import { useTranslation } from 'react-i18next';
import ScoreBlock from '../ScoreBlock';
import BurnoutAlert from '../BurnoutAlert';
import {
  BenchMarkScoreMetaData,
  WidgetDefinition,
} from '../../../../shared/types/widget';
import useFilters from '../../../../utilities/hooks/useFilters';
import { SelectedBenchmark } from '../../../../shared/constants/filter/filter';
import { Typography } from '../../../widgets/Typography';

interface DimensionScoreCardProps {
  definition: WidgetDefinition;
  content: BenchMarkScoreMetaData;
}

function DimensionScoreCard({ definition, content }: DimensionScoreCardProps) {
  const { benchmarkType } = useFilters();
  const { t } = useTranslation();

  return (
    <div>
      <Typography variant="display-xs" weight="bold" className="mb-2">
        {t('SCORE')}
      </Typography>
      <div className="mb-4 flex items-center gap-x-2">
        <ScoreBlock highlightScore scoreData={content} />
        <span className="text-grey-800 text-lg font-medium">
          (
          {benchmarkType == SelectedBenchmark.GLOBAL
            ? t('GLOBAL')
            : t('INDUSTRY')}{' '}
          {t('AVG')}: {Math.round(content?.data?.average)})
        </span>
      </div>
      {content?.meta?.info && (
        <BurnoutAlert className="mb-4" info={content?.meta?.info} />
      )}
      <div className="font-work-sans text-grey-900 mb-4 text-2xl font-semibold">
        {content?.data?.title}
      </div>
      <div className="text-grey-700 text-lg">{content?.data?.description}</div>
    </div>
  );
}

export default DimensionScoreCard;
